import React from 'react';
import { ShieldOff, ShieldCheck, X, Check } from 'lucide-react';

const BeforeAfterSection = () => {
  return (
    <section className="py-24 bg-[#F4F4F5]" data-testid="before-after-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">The Difference</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            Unprotected vs. Legally Protected
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {/* Before */}
          <div className="card-hover bg-white rounded-lg overflow-hidden" data-testid="before-card">
            <div className="relative h-56 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1616021204943-751615d5cc93?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxtZXNzeSUyMHNjYXR0ZXJlZCUyMHBhcGVycyUyMGNoYW9zJTIwZGlzb3JnYW5pemVkJTIwZGVzayUyMGRhcmt8ZW58MHx8fHwxNzc1NTA4NjU3fDA&ixlib=rb-4.1.0&q=85" alt="Unprotected brand" className="w-full h-full object-cover grayscale opacity-70" />
              <div className="absolute inset-0 bg-gradient-to-t from-white/80 to-transparent" />
              <div className="absolute bottom-4 left-6 flex items-center gap-2">
                <div className="w-10 h-10 bg-zinc-200 rounded-md flex items-center justify-center">
                  <ShieldOff className="w-5 h-5 text-zinc-500" />
                </div>
                <span className="text-lg font-bold text-zinc-700" style={{fontFamily:'Outfit,sans-serif'}}>Without Protection</span>
              </div>
            </div>
            <div className="p-6">
              <div className="space-y-3">
                {[
                  'Anyone can copy your brand name or logo',
                  'No legal recourse against infringement',
                  'Blocked from Amazon Brand Registry',
                  'Cannot use the \u00AE registered symbol',
                  'Brand value remains unprotected',
                ].map((text) => (
                  <div key={text} className="flex items-start gap-3">
                    <X className="w-4 h-4 text-red-400 mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-zinc-500">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* After */}
          <div className="bg-[#002FA7] rounded-lg overflow-hidden shadow-lg" data-testid="after-card">
            <div className="relative h-56 overflow-hidden">
              <img src="https://images.unsplash.com/photo-1761123261084-53c40fe1e607?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwb3JnYW5pemVkJTIwZGVzayUyMGNsZWFufGVufDB8fHx8MTc3NTUwMjg1Mnww&ixlib=rb-4.1.0&q=85" alt="Protected brand" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#002FA7]/90 to-transparent" />
              <div className="absolute bottom-4 left-6 flex items-center gap-2">
                <div className="w-10 h-10 bg-white/20 backdrop-blur-sm rounded-md flex items-center justify-center">
                  <ShieldCheck className="w-5 h-5 text-white" />
                </div>
                <span className="text-lg font-bold text-white" style={{fontFamily:'Outfit,sans-serif'}}>With Trademark Protection</span>
              </div>
            </div>
            <div className="p-6">
              <div className="space-y-3">
                {[
                  'Exclusive nationwide rights to your brand',
                  'Full legal power to stop copycats',
                  'Qualifies for Amazon Brand Registry',
                  'Use the \u00AE symbol with authority',
                  'Increases business valuation and credibility',
                ].map((text) => (
                  <div key={text} className="flex items-start gap-3">
                    <Check className="w-4 h-4 text-white/80 mt-0.5 flex-shrink-0" />
                    <span className="text-sm text-white/80">{text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfterSection;
